import { ApolloProvider } from '@apollo/client/react';

import { PlanBenchmarkWidget } from '../features/plan-benchmark/PlanBenchmarkWidget';
import { client } from '../graphql/client';
import { IdempotencyProviderWithFeatureRegistry } from '../providers/IdempotencyProviderWithFeatureRegistry';

type Props = { planId: string };

export const PlanBenchmarkApp: React.FC<Props> = ({ planId }) => (
  <ApolloProvider client={client}>
    <IdempotencyProviderWithFeatureRegistry featureName="planBenchmark">
      <PlanBenchmarkWidget planId={planId} />
    </IdempotencyProviderWithFeatureRegistry>
  </ApolloProvider>
);

PlanBenchmarkApp.displayName = 'PlanBenchmarkApp';
